import convesionImg from "assets/images/face-3.jpg";
import convesionImg2 from "assets/images/face-4.jpg";
import convesionImg3 from "assets/images/face-5.jpeg";
import convesionImg4 from "assets/images/face-6.jpeg";
import convesionImg5 from "assets/images/face-2.jpg";
import project1 from "assets/images/home-decor-1.jpeg";
import project2 from "assets/images/home-decor-2.jpeg";
import project3 from "assets/images/home-decor-3.jpeg";

const data = [
  {
    title: "Sophie B.",
    avatar: convesionImg,
    description: "Hi! I need more information…",
  },
  {
    title: "Anne Marie",
    avatar: convesionImg2,
    description: "Awesome work, can you…",
  },
  {
    title: "Ivan",
    avatar: convesionImg3,
    description: "About files I can…",
  },
  {
    title: "Peterson",
    avatar: convesionImg4,
    description: "Have a great afternoon…",
  },
  {
    title: "Nick Daniel",
    avatar: convesionImg5,
    description: "Hi! I need more information…",
  },
];

const project = [
  {
    img: project1,
    titlesub: "Project #1",
    title: "Modern",
    disciption:
      "As Uber works through a huge amount of internal management turmoil.",
  },
  {
    img: project2,
    titlesub: "Project #2",
    title: "Scandinavian",
    disciption:
      "Music is something that every person has his or her own specific opinion about.",
  },
  {
    img: project3,
    titlesub: "Project #3",
    title: "Minimalist",
    disciption:
      "Different people have different taste, and various types of music, Zimbali Resort",
  },
];

export { project, data };
